import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { strings } from 'APP_ROOT/localization';
import EditableLabel from 'APP_ROOT/components/EditableLabel';
import {Selectors, DispatchHelpers as Actions} from '../../../../../../data/assetMonitoring'
import constants from '../../../../../../data/assetMonitoring/constants'

class Name extends React.Component {

    state = {
        editing: false
    }

    componentDidUpdate(prevProps) {
        // If selection changes while editing, we discard the edit
        if(prevProps.assetUuid !== this.props.assetUuid && this.state.editing) {
            this.cancelEditing();
        }
    }

    save = (value) => {
        this.props.onChange(value);
        
        this.setState({
            editing: false
        });
    }

    cancelEditing = () => {
        this.setState({
            editing: false
        });
    }

    startEditing = () => {
        this.setState({
            editing: true
        });
    }

    render () {

        const {
            name,
            pending,
            maxLength,
        } = this.props;

        return (
            <section className="asset-name">
                <EditableLabel
                    value={name}
                    editing={this.state.editing}
                    loading={pending}
                    onRequestEdit={this.startEditing}
                    onChange={this.save}
                    onCancel={this.cancelEditing}
                    maxLength={maxLength}
                />
            </section>
        )
    }
}

Name.propTypes = {
    name: PropTypes.string.isRequired,
    assetUuid: PropTypes.string,
    pending: PropTypes.bool.isRequired,
    maxLength: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
    return {
        name: Selectors.assetName(state, ownProps.assetUuid),
        pending: Selectors.assetNameChangePending(state, ownProps.assetUuid),
        maxLength: constants.ASSET_NAME_MAX_LENGTH,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (name) => dispatch(
            Actions.setAssetName(ownProps.assetUuid, name)
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Name);